import axios from 'axios';
import axiosRetry from 'axios-retry';

const BASEPATH =
	window.REACT_API_BASE_URL ||
	'https://retailer-dev.data.api.corpinter.net/backend';

// Dedicated instance so retries don't affect the shared axios singleton used elsewhere in the app.
const vimdtAxios = axios.create();

axiosRetry(vimdtAxios, {
	retries: 3,
	// Only retry transient/network failures and idempotent methods; never retry 4xx or non-idempotent POSTs.
	retryCondition: axiosRetry.isNetworkOrIdempotentRequestError,
});

export const _getVehicleImages = (params) => {
	const { vin, apikey, queries } = params;
	return vimdtAxios.get(`${BASEPATH}/business_bundle/vehicles/${vin}`, {
		params: { ...queries, imageUrl: true },
		headers: { 'x-api-key': apikey },
	});
};

export const _getImage = (params) => {
	const { imageId } = params;
	return vimdtAxios.get(`${imageId}`, { responseType: 'arraybuffer' });
};

export const _getFreemiumImages = (params) => {
	const { marketId } = params;
	return vimdtAxios.get(`${BASEPATH}/freemium_bundle/${marketId}`);
};

export const _getEquipment = (params) => {
	const { apikey, vin, marketId } = params;
	return vimdtAxios.get(`${BASEPATH}/equipment_bundle/${vin}`, {
		headers: { 'x-api-key': apikey },
		params: { marketId },
	});
};

export const _getSpesification = (params) => {
	const { vin, apikey } = params;
	const query = { ...params, vin: undefined, apikey: undefined };

	return vimdtAxios
		.get(`${BASEPATH}/specification_bundle/${vin}`, {
			headers: { 'x-api-key': apikey },
			params: { ...query },
		})
		.catch((err) => {
			if (err.response) {
				if (err.response.status === 404) {
					return { data: 'No data found', status: 404 };
				}
				throw err;
			}
			throw err;
		});
};

const noContentAware = (url, apikey, marketId) =>
	vimdtAxios
		.get(url, {
			headers: { 'x-api-key': apikey },
			params: { marketId },
		})
		.then((response) =>
			response.status === 204 ? { data: 'No data found', status: 204 } : response
		)

export const _getEmissionSpecification = (params) => {
	const { marketId, vin, apikey } = params;
	return noContentAware(`${BASEPATH}/emission_specification_bundle/${vin}`, apikey, marketId);
};

export const _getEquipmentSpecification = (params) => {
	const { marketId, vin, apikey } = params;
	return noContentAware(`${BASEPATH}/equipment_specification_bundle/${vin}`, apikey, marketId);
};

export const _getSimSearchSpecification = (params) => {
	const { marketId, vin, apikey } = params;
	return noContentAware(`${BASEPATH}/simsearch_specification_bundle/${vin}`, apikey, marketId);
};

export const _getRycSpecification = (params) => {
	const { marketId, vin, apikey } = params;
	return noContentAware(`${BASEPATH}/ryc_specification_bundle/${vin}`, apikey, marketId);
};

export const _getUrlImage = (params) => {
	const { imageUrl } = params;
	return vimdtAxios.post(`${BASEPATH}/images`, { imageUrl }, { responseType: 'arraybuffer' });
};

export const _getUrlImageAll = (params) =>
	axios.all(
		params.map((imageUrl) =>
			vimdtAxios.post(
				`${BASEPATH}/images`,
				{ imageUrl: imageUrl.url },
				{ responseType: 'arraybuffer' }
			)
		)
	);

export const _getAvailableBackgrounds = (params) => {
	const { vin, apikey } = params;
	return vimdtAxios.get(`${BASEPATH}/content_bundle/backgrounds/${vin}`, {
		headers: { 'x-api-key': apikey },
	});
};

export const _getModelInformation = (params) => {
	const {
		marketId,
		baumuster,
		modelYear,
		changeYear,
		nationalSalesType,
		technicalData,
		apikey,
	} = params;
	return vimdtAxios.get(`${BASEPATH}/models_ccs_bundle/`, {
		headers: { 'x-api-key': apikey },
		params: { marketId, baumuster, modelYear, changeYear, nationalSalesType, technicalData },
	});
};

export const _mock = (data) =>
	new Promise((resolve) => setTimeout(() => resolve({ data }), 800));
